import React from 'react';

import { MODALS } from 'global-constants';
import { toggleHubspotChat } from 'shared/utils/common';
import { withModal } from 'shared/components/Modals';
import { default as Modal } from 'shared/components/Modals/GenericModal';
import Button from 'shared/components/Button';

import styles from './styles.module.scss';

const SuccessChangePlanModal = props => (
  <Modal closeModal={props.closeModal}>
    <div className={styles.successChangePlanModalWrapper}>
      <div className={styles.container}>
        <div className={styles.title}>
          Congratulations, you're now a Data Explorer!
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.successText}>
            If you'd like to talk with one of our Data Warriors to help you get
            the most out of our data, please contact us.
          </div>
          <Button
            onClick={() => {
              toggleHubspotChat();
              props.closeModal();
            }}
            className={styles.successBtn}
            color="brand-green">
            Contact Us
          </Button>
        </div>
      </div>
    </div>
  </Modal>
);

export default withModal(MODALS.SUCCESS_CHANGE_PLAN)(SuccessChangePlanModal);
